import {
    AfterContentChecked,
    AfterViewChecked,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewChild,
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {
    SelectProduitRootComponent
} from '../../../../../../modules/widget/components/form/select/select-produit-root/select-produit-root.component';

@Component({
    selector: 'app-edit-dialog-produit',
    templateUrl: './edit-dialog-produit.component.html',
    styleUrls: ['./edit-dialog-produit.component.css'],
})
export class EditDialogProduitComponent
    implements OnInit, AfterContentChecked, AfterViewInit, AfterViewChecked {
    @ViewChild('fils1') fils1: SelectProduitRootComponent;
    @ViewChild('rootprod') rootprod: SelectProduitRootComponent;
    @ViewChild('rooract') rooract: SelectProduitRootComponent;
    @ViewChild('fils2') fils2: SelectProduitRootComponent;
    @ViewChild('fils3') fils3: SelectProduitRootComponent;
    t: any;
    form: FormGroup;
    idfils1: any;
    idfils2: any;
    idfils3: any;
    root: any;
    cat: any;

    constructor(
        private dialogRef: MatDialogRef<EditDialogProduitComponent, { data: any }>,
        private cdref: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) data: { t: any }
    ) {
        this.t = data;


    }

    onSuccessAdd() {
        if (this.form.valid) {
            const data = this.form.getRawValue();

            this.dialogRef.close({
                data: data,
            });
        }
    }

    ngOnInit(): void {
        this.root = this.t.cateId.toString().substring(0, 2);
        this.idfils1 = this.t.cateId.toString().substring(0, 4);
        this.idfils2 = this.t.cateId.toString().substring(0, 6);
        this.idfils3 = this.t.cateId.toString().substring(0, 8);
        this.cat = this.t.cateId;
        this.form = new FormGroup({
            cateId: new FormControl({value: this.t.cateId, disabled: true}, [
                Validators.required,
            ]),
            name: new FormControl({value: this.t.name, disabled: true}, [
                Validators.required,
            ]),
            makeFl: new FormControl(this.t.makeFl, [Validators.required]),
            root: new FormControl(null, Validators.required),
            racine: new FormControl(null, Validators.required),
            fils1: new FormControl(null, Validators.required),
            fils2: new FormControl(null, Validators.required),
        });
    }

    ngAfterContentChecked() {
    }

    getFormControl(key: string): FormControl {
        return this.form.controls[key] as FormControl;
    }

    sendfromroot(value) {
        this.root = value.cateId;
        this.form.get('root').setValue(null);
        this.form.get('fils1').setValue(null);
        this.form.get('fils2').setValue(null);
    }

    send(value) {
        this.idfils1 = value.cateId;
        this.form.get('fils1').setValue(null);
        this.form.get('fils2').setValue(null);
    }

    sendfils(value: any) {
        this.idfils2 = value.cateId;

        this.form.get('fils2').setValue(null);
    }

    sendfils2(value: any) {
        this.form.get('cateId').setValue(value.cateId);
        this.form.get('name').setValue(value.cateNm);
    }

    ngAfterViewInit(): void {
        setTimeout((x) => {
            const t0 = this.getFormControl('cateId').value.toString().substring(0, 2);
            const t1 = this.getFormControl('cateId').value.toString().substring(0, 4);
            const t2 = this.getFormControl('cateId').value.toString().substring(0, 6);
            const t3 = this.getFormControl('cateId').value.toString().substring(0, 8);

            const root = this.rooract.list.find((e) => Number(e.cateId) == Number(t0))
                .cateId;
            this.form.get('racine').setValue(root);
            setTimeout((x) => {
                const racine = this.rootprod.list.find(
                    (e) => Number(e.cateId) == Number(t1)
                ).cateId;
                this.form.get('root').setValue(racine);
                setTimeout((x) => {
                    const fils1 = this.fils1.list.find(
                        (e) => Number(e.cateId) == Number(t2)
                    ).cateId;
                    this.form.get('fils1').setValue(fils1);
                }, 100);
                setTimeout((x) => {
                    const fils2 = this.fils2.list.find(
                        (e) => Number(e.cateId) == Number(t3)
                    )?.cateId;
                    this.form.get('fils2').setValue(fils2);
                }, 200);
            }, 300);
        }, 600);
    }

    ngAfterViewChecked(): void {
    }
}
